export const DELIMITER = ','